<template>
  <v-container fluid class="automation-container pa-0 ma-0">
    <!-- Modern Header Section -->
    <v-row v-if="showHeader" class="pa-0 ma-0 px-3 mb-4">
      <v-col cols="12" class="pa-0">
        <div class="header-section mb-4" style="position: relative;">
          <v-btn icon small class="header-close-btn" @click="dismissHeader">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
          <v-container fluid class="px-3">
            <v-row align="center" class="pa-0 ma-0">
              <v-col cols="12" md="8" class="d-flex align-center pa-0">
                <div class="header-icon-wrapper mr-4">
                  <v-icon size="32" color="#FFFFFF">mdi-robot-outline</v-icon>
                </div>
                <div>
                  <h1 class="page-title mb-1">WhatsApp Automation</h1>
                  <p class="page-subtitle mb-0">
                    Automate your WhatsApp messaging with smart rules
                  </p>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="text-right pa-0">
                <v-chip small color="rgba(255,255,255,0.2)" text-color="white">
                  <v-icon small left color="white">mdi-whatsapp</v-icon>WhatsApp
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="mt-4">
              <v-col cols="12" class="pa-0">
                <div class="feature-pills-container">
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white">mdi-robot</v-icon>
                    Auto-Reply
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-clock-fast</v-icon
                    >
                    Trigger Rules
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-message-flash</v-icon
                    >
                    Quick Responses
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-chart-timeline</v-icon
                    >
                    Workflow
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>
    </v-row>

    <v-flex
      v-if="!isConnected && !whatsappRegistered"
      xs12
      sm12
      md12
      style="padding: 1%"
    >
      <WhatsappConnector
        :is-connected="isConnected"
        :whatsapp-registered="whatsappRegistered"
        :set-chat-show="setChatShow"
      />

      <PayWallCard
        title="Unlock WhatsApp Automation"
        description="Automate responses and workflows for better efficiency"
        badge="Premium Feature"
        badge-icon="mdi-whatsapp"
        badge-color="success"
        :features="whatsappFeatures"
        button-text="Upgrade Now"
      />
    </v-flex>

    <v-card
      v-else
      fluid
      flat
      tile
      min-height="92vh"
      class="back mb-n15 pa-6 px-md-15 customBorderRadius ma-2"
    >
      <v-card-text v-for="list in lists" :key="list.id" class="">
        <h3>{{ list.name }}</h3>
        <automation-rules
          :list="list"
          :all-lists="lists"
          :page-name="pageName"
          @refresh="refresh()"
        />
      </v-card-text>

      <PayWallCard
        title="Unlock WhatsApp Automation"
        description="Automate responses and workflows for better efficiency"
        badge="Premium Feature"
        badge-icon="mdi-whatsapp"
        badge-color="success"
        :features="whatsappFeatures"
        button-text="Upgrade Now"
      />
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import automationRules from "../../components/automationRules.vue";
import WhatsappConnector from "../../components/whatsappConnector.vue";
import PayWallCard from "@/components/payWallCard.vue";
const _ = require("lodash");
export default {
  components: { automationRules, WhatsappConnector, PayWallCard },
  data: () => ({
    showHeader: false,
    isConnected: false,
    whatsappRegistered: false,
    lists: [],
    rules: [],
    pageName: "Whatsapp_Automation",
    whatsappFeatures: [
      "Auto-reply to incoming messages",
      "Trigger-based message sequences",
      "Keyword-based responses",
      "Business hours automation",
    ],
  }),
  computed: {
    ...mapGetters([
      "ENDPOINT",
      "dispoList",
      "teams",
      "user",
      "selectedTeam",
      "selectedList",
    ]),
  },
  async created() {
    this.showHeader =
      localStorage.getItem("whatsappAutomationHeaderDismissed") !== "true";
    const getIntegration = await this.$http.get(
      `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.user.companyId}&filter[where][type]=whatsapp`,
    );
    console.log("integrations details: ", getIntegration.body);
    if (
      getIntegration.body.length &&
      getIntegration.body[0].config.initializeDone
    ) {
      this.setChatShow();
      await this.fetchLists();
    }

    // this.getRules();
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("whatsappAutomationHeaderDismissed", "true");
    },
    setChatShow() {
      this.isConnected = true;
      this.whatsappRegistered = true;
    },
    // async getRules(listId) {
    //     var res = await this.$http.get(
    //         `${this.ENDPOINT}/lists/${listId}?filter[fields][triggers]=true`
    //     );
    //     this.rules = res.body.triggers || [];
    //     console.log("Rules: ",this.rules);
    //     return this.rules;
    //     },
    async refresh() {
      console.log("Refresh in automation Parent");
      await this.fetchLists();
    },
    getTeamIds() {
      var teams = [];
      if (this.selectedTeam == "allTeams") {
        teams = _.map(this.teams, "id");
      } else {
        teams.push(this.selectedTeam);
      }
      teams = _.without(teams, "allTeams");
      return teams;
    },
    async fetchLists() {
      this.lists = [];
      var teamIds = await this.getTeamIds();
      await this.$http
        .post(`${this.ENDPOINT}/lists/fetch`, { teams: teamIds })
        .then((res) => {
          this.lists = res.body;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>
.automation-container {
  background-color: var(--v-background-base, #f5f5f5);
}

.theme--dark .automation-container {
  background-color: #121212 !important;
}
</style>
